export default "__VITE_ASSET__46a98da6__"